import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import {SeFePaginationOptions} from 'se-fe-pagination';
import {ProductManagementErrorInterface} from '../../../error/error-handling/product-management-error';
import {Bundle, CollectionMetadata} from '../../../models/clare';
import {buildPaginationOptions} from '../../../utils/pagination-utils';
import * as fromBundleList from './bundle-list.reducer';

export const selectBundleListState = createFeatureSelector<fromBundleList.BundleListState>(
  fromBundleList.bundleListFeatureKey
);

export const selectBundles: MemoizedSelector<object, Bundle[]> = createSelector(
  selectBundleListState,
  fromBundleList.getItems
);

export const selectBundleListPaginationMeta: MemoizedSelector<object, CollectionMetadata> = createSelector(
  selectBundleListState,
  fromBundleList.getPaginationMeta
);

export const selectBundleListPaginationOptions: MemoizedSelector<object, SeFePaginationOptions> = createSelector(
  selectBundleListPaginationMeta,
  paginationMeta => buildPaginationOptions(paginationMeta, {label: 'Bundles'})
);

export const selectBundleListLoading: MemoizedSelector<object, boolean> = createSelector(
  selectBundleListState,
  fromBundleList.getLoading
);

export const selectBundleListError: MemoizedSelector<object, ProductManagementErrorInterface | undefined> =
  createSelector(selectBundleListState, fromBundleList.getError);
